// nicks/ui-nick-create-panel.js
import { createPanelController } from '../shared/ui-panel-base.js';
import { getNicks, setNicks } from '../state-manager.js';
import { loadClientNicks, createClientNicks } from '../requests/clients.js';
import { closePanel } from '../shared/ui-panel-controller.js';

let localNicks = [];

export const createNickPanel = createPanelController('settings-nick-create', {
  onOpen: () => {
    localNicks = getNicks().map(n => ({
      nick: n.nick,
    }));
    // const nickInput = document.getElementById('settings-exist-nick-input');
    // nickInput.value = localNicks.map(n => n.nick).join(', ');

    console.log('[NickCreatePanel] Opening nick create panel');
  },
  onClose: () => {
    console.log('[NickCreatePanel] Closing nick create panel');
    localNicks.length = 0;
  },
});


// Submit button handler
document.getElementById('settings-submit-nicks')?.addEventListener('click', async () => {
  let newNicks = document.getElementById('settings-new-nick-input')?.value.trim();
  
  // Split nicks by comma and trim whitespace
  const payload = (newNicks ? newNicks.split(",").map(n => n.trim()) : []);

  try {
    await createClientNicks(payload);
    const refreshed = await loadClientNicks();
    // const nicks = refreshed.nicks.map(n => ({
    //   nick: n.nick,
    // }));
    setNicks(refreshed);
    createNickPanel.close();
  } catch (err) {
    console.error('Nick create failed:', err);
    alert('Unable to add nicknames.');
  }
});

document.querySelector('#settings-nick-create-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[NickCreatePanel] Back to settings from nick create panel');
  closePanel('settings-nick-create'); // Will automatically restore previous panel (e.g. settings)
});  
